import React from 'react';

const PLATFORMS = [
    { value: 'all',    label: 'Tất cả', emoji: '🔥', activeClass: 'bg-orange-500 text-white shadow-orange-200' },
    { value: 'shopee', label: 'Shopee', emoji: '🛒', activeClass: 'bg-[#EE4D2D] text-white shadow-red-200' },
    { value: 'lazada', label: 'Lazada', emoji: '💜', activeClass: 'bg-[#0F146B] text-white shadow-indigo-200' },
    { value: 'tiktok', label: 'TikTok', emoji: '🎵', activeClass: 'bg-[#010101] text-white shadow-gray-400' },
];

function TrendingPlatformFilter({ platform, onChange }) {
    return (
        <div className="flex gap-2 mx-3 mt-2 px-3 py-2 bg-surface rounded-xl overflow-x-auto scrollbar-hide sticky top-16 z-10">
            {PLATFORMS.map((p) => {
                const isActive = platform === p.value;
                return (
                    <button
                        key={p.value}
                        onClick={() => onChange(p.value)}
                        className={`flex items-center gap-1.5 px-4 py-1.5 rounded-full text-sm font-semibold whitespace-nowrap transition-all duration-200 flex-shrink-0 ${
                            isActive
                                ? `${p.activeClass}`
                                : 'bg-surface-muted text-content-3 hover:bg-surface-raised hover:text-content-2'
                        }`}
                    >
                        <span className="text-base leading-none">{p.emoji}</span>
                        {p.label}
                    </button>
                );
            })}
        </div>
    );
}

export default TrendingPlatformFilter;
